import { render, staticRenderFns } from "./examinationRecord.vue?vue&type=template&id=746d47e0&scoped=true"
import script from "./examinationRecord.vue?vue&type=script&lang=js"
export * from "./examinationRecord.vue?vue&type=script&lang=js"
import style0 from "./examinationRecord.vue?vue&type=style&index=0&id=746d47e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d47e0",
  null
  
)

export default component.exports